import React from "react";
import { Card, Row, Col, Container, Button, Image } from "react-bootstrap";

const AppSettings = () => {
  return (
    <Container className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>App Settings</h1>
        {/* <Button variant="primary">Edit</Button> */}
      </div>

      {/* Company Info */}
      <Row className="mb-4">
        <Col md={3}><strong>Company Name</strong><br />Mettle Tech</Col>
        <Col md={3}><strong>App Title</strong><br />Mettastay Pos</Col>
        <Col md={3}><strong>App Timezone</strong><br />Asia/Kolkata</Col>
        <Col md={3}><strong>App Date Time Format</strong><br />j-n-Y h:i A</Col>
      </Row>
      <Row className="mb-4">
        <Col md={3}><strong>App Date Format</strong><br />d-m-Y</Col>
        <Col md={3}><strong>Updated By</strong><br />Mettle Tech (SA)</Col>
        <Col md={3}><strong>Updated On</strong><br />29-9-2023 07:17 PM</Col>
      </Row>

      {/* Logos */}
      <Row className="text-left mb-4">
        {[
          { title: "Company Logo" },
          { title: "Invoice Print Logo" },
          { title: "Top Navbar Logo" },
          { title: "Favicon" }
        ].map((item, index) => (
          <Col md={3} key={index}>
            <strong>{item.title}</strong>
            <br />
            <img src={require('../../../../../GlobalModules/Utility/Public/images/MPOS.png')} style={{width:'auto'}} />
          </Col>
        ))}
      </Row>

      {/* Default Customer Details */}
      <h2 className="mb-3">Default Customer Details</h2>
      <Row>
        <Col md={4}><strong>Name</strong><br />Walkin Customer</Col>
        <Col md={4}><strong>Email</strong><br />walkincustomer@mettletech.in</Col>
        <Col md={4}><strong>Phone</strong><br />0000000000</Col>
      </Row>
    </Container>
  );
};

export default AppSettings;
